import { ContentfulEntry } from '@jbhi-fi/apis/src/contentful/types';

export const useContentMetafieldData = <T extends ContentfulEntry<any>>(): T => {
  const skeletonData = window?.Jbhifi?.contentfulData;
  if (!skeletonData) {
    throw new Error('Could not find contentful data on window');
  }
  return {
    sys: skeletonData.sys,
    metadata: skeletonData.metadata,
    fields: skeletonData.fields,
  } as T;
};
